/**
 * Sélecteur de gamme des best sellers (mobile) : le choix d'une gamme
 * FILTRE le carrousel sur place, il ne quitte plus la page (retour
 * mhkdesign 2026-09-03). Le bouton ne porte que le nom court de la gamme
 * (« Éco », « Premium ») pour tenir à droite du titre, sur sa ligne.
 *
 * Une gamme est reconnue par une étiquette produit (`data-gamme-tag` sur
 * l'entrée, `data-tags` sur les cartes). Une entrée sans étiquette reste un
 * lien ordinaire : la navigation suit.
 *
 * Délégation sur le document, comme rail.js : l'éditeur de thème remplace
 * le HTML de la section à chaque réglage, ce qui décrocherait des
 * écouteurs posés sur les éléments.
 */
const NOM_COURT = /^(gamme|collection)\s+/i;

function etiquettes(carte) {
  return (carte.dataset.tags || '').split('|').filter(Boolean);
}

function filtrer(section, tag) {
  const rail = section.querySelector('.hm-deal-rail');
  if (!rail) return;
  rail.querySelectorAll('.cat-card').forEach((carte) => {
    carte.hidden = Boolean(tag) && !etiquettes(carte).includes(tag);
  });
  rail.scrollTo({ left: 0 });
  // rail.js recalcule l'état de ses flèches sur le défilement.
  rail.dispatchEvent(new Event('scroll'));
}

function poser(pick, entree) {
  const nom = pick.querySelector('[data-gamme-nom]');
  if (nom) {
    nom.textContent = entree
      ? entree.textContent.trim().replace(NOM_COURT, '')
      : nom.dataset.gammeNeutre;
  }
  pick.querySelectorAll('.hm-fav-pick-m [aria-current]').forEach((c) => {
    c.setAttribute('aria-current', String(c === (entree || pick.querySelector('[data-gamme-tout]'))));
  });
  pick.removeAttribute('open');
}

document.addEventListener('click', (event) => {
  const entree = event.target.closest('[data-gamme-tag], [data-gamme-tout]');
  if (!entree) return;
  const pick = entree.closest('[data-gamme-pick]');
  const section = entree.closest('.shopify-section');
  if (!pick || !section) return;

  event.preventDefault();
  const tag = entree.dataset.gammeTag || null;
  poser(pick, tag ? entree : null);
  filtrer(section, tag);
});

// Un clic hors du sélecteur le referme, comme un menu.
document.addEventListener('click', (event) => {
  document.querySelectorAll('[data-gamme-pick][open]').forEach((pick) => {
    if (!pick.contains(event.target)) pick.removeAttribute('open');
  });
});
